import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveries } from "../../constants";
import {
  GetDeliveriesByDriverRequestParams,
  GetDeliveriesByDriverResponse
} from "./getDeliveriesByDriver.types";

export const requestGetDeliveriesByDriver = async ({
  driverId,
  ...params
}: GetDeliveriesByDriverRequestParams): Promise<GetDeliveriesByDriverResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesDeliveries.Driver,
      driverId,
      ApiRoutesDeliveries.DriverDeliveries
    ),
    { params }
  );
};
